<template>
    <div v-if="show && loaded" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="popup-form">
                <NevsTextField v-model="name" :error="validation.name"
                               :label="'*' + $LANG.Get('fields.name') + ':'"></NevsTextField>
                <NevsNumberField v-model="capacity" :decimal-places="0" :error="validation.capacity"
                                 :label="'*' + $LANG.Get('fields.capacity') + ':'"></NevsNumberField>
                <NevsCheckbox v-model="active" :label="$LANG.Get('fields.activeF')"></NevsCheckbox>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()">
                    <i class="fa-solid fa-xmark"></i>
                    {{ $LANG.Get('buttons.cancel') }}
                </NevsButton>
                <NevsButton class="success" @click="okClick()">
                    <i class="fa-solid fa-check"></i>
                    {{ $LANG.Get('buttons.ok') }}
                </NevsButton>
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";

export default {
    name: "ModalEditRoom",
    components: {NevsCheckbox, NevsTextField, NevsNumberField, NevsButton},
    props: {
        show: {
            type: Boolean,
            default: false
        },
        room: {
            type: Object,
            default: null
        }
    },
    emits: ['done'],
    data() {
        return {
            loaded: false,
            name: '',
            capacity: 1,
            active: true,
            validation: {
                name: '',
                capacity: ''
            }
        }
    },
    watch: {
        show() {
            this.loaded = false;
            this.validation.name = '';
            this.validation.capacity = '';
            if (this.show) {
                if (this.room !== null) {
                    this.name = this.room.name;
                    this.capacity = this.room.capacity;
                    this.active = this.room.active;
                } else {
                    this.name = '';
                    this.capacity = 1;
                    this.active = true;
                }
                this.$nextTick(() => {
                    this.loaded = true;
                });
            }
        }
    },
    methods: {
        cancelClick() {
            this.$emit('done', false);
        },
        okClick() {
            let valid = true;
            if (this.name === null || this.name.trim() === '') {
                this.validation.name = this.$LANG.Get('labels.mandatoryField');
                valid = false;
            } else {
                this.validation.name = '';
            }
            if (this.capacity === '' || this.capacity === null || this.capacity <= 0) {
                this.validation.capacity = this.$LANG.Get('labels.mandatoryField');
                valid = false;
            } else {
                this.validation.capacity = '';
            }
            if (!valid) {
                return;
            }

            let vm = this;
            let method = this.room === null ? 'post' : 'put';
            let action = this.room === null ? 'rooms' : 'rooms/' + this.room.id;
            this.$API.APICall(method, action, {
                name: this.name,
                capacity: this.capacity,
                active: this.active
            }, (data, success) => {
                if (success) {
                    vm.$emit('done', true);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    }
}
</script>

<style scoped>
.nevs-popup {
    max-width: 500px;
}

.popup-form {
    padding: 10px;
}
</style>
